// extracted by mini-css-extract-plugin
export default {"rootTouchBuffer":"Handle_rootTouchBuffer__FYk6v","visibleHandle":"Handle_visibleHandle__fiGVY","dragged":"Handle_dragged__b2WHr"};